module.exports = __webpack_public_path__ + "static/media/icons_Reprise de traitement - t‚l‚soin.8337de69.svg";